import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  ButtonXS,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import walletImg from "../../styles/images/img_wallet.png";
import { checkMobile } from "../../components/hooks/basicFunc";
import { Loading } from "../../components/modal/Loading";

const CheckWallet = () => {
  const navigate = useNavigate();
  // const [signClient, setSignClient] = useState();
  // const [session, setSession] = useState([]);
  // const [account, setAccount] = useState([]);
  // const [sigResult, setSigResult] = useState();

  const userAgent = checkMobile();

  const handleInstallApp = () => {
    if (userAgent == "ios") {
      window.open(
        "https://apps.apple.com/kr/app/%EB%B6%80%EB%A6%AC%EB%98%90-%EC%9B%94%EB%A0%9B-burrito-wallet/id6449563083"
      );
    } else if (userAgent == "android") {
      window.open(
        "https://play.google.com/store/apps/details?id=com.burritowallet.app&hl=ko&gl=US"
      );
    } else {
      window.open("https://www.burritowallet.com/");
    }
  };

  return (
    <OnePageLayout title="AMO 포인트 교환">
      <Section>
        <Content>
          <TextDiv>
            <h3>
              AMO 포인트 교환을 위해
              <br />
              <span className="col">부리또 웰렛</span>의 주소를 등록해주세요.
            </h3>
          </TextDiv>

          <ImgWrap margintop="9.3" imgwidth="8">
            <img src={walletImg} alt="" />
          </ImgWrap>
          <SecondTextDiv>
            <p>
              포인트를 AMO 코인으로 교환하기 위해서는
              <br />
              고객님 폰에 부리또 월렛이 설치되어 있어야 합니다.
            </p>
          </SecondTextDiv>
          <WalletBtnWrap>
            <ButtonXS col="purple_secondary" onClick={handleInstallApp}>
              브리또 월렛 설치
            </ButtonXS>
          </WalletBtnWrap>
        </Content>
        <Btns>
          <Desc>부리또 월렛이 설치 되어 있다면 주소를 등록해주세요.</Desc>
          <ButtonL onClick={() => navigate("/amo/wallet/add")}>
            {/* <ButtonL onClick={handleConnect}>주소 등록 하러가기 */}
            주소 등록 하러가기
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default CheckWallet;
const SecondTextDiv = styled(TextDiv)`
  margin-top: 2rem;
`;
const WalletBtnWrap = styled.div`
  button {
    height: 4rem;
    border-radius: 2rem;
    width: 14rem;
    margin: 2rem auto 0 auto;
  }
  text-align: center;
`;
const Desc = styled.p`
  text-align: center;
  font-size: 1.4rem;
  line-height: 2rem; /* 142.857% */
  margin-bottom: 1rem;
`;
